// import React from "react";
// import { PhoneInput } from "react-international-phone";
// import "react-international-phone/style.css";

// export const PhoneNumber = ({
//   label = "",
//   defaultCountry = "in",
//   className = "",
//   onChange,
//   onBlur,
//   phone,
//   placeholder,
//   disabled,
//   handlePhoneChange,
//   error,
//   inputClassName = "",
//   ...props
// }) => {
//   const handleChange = (val, inputdata) => {
//     // Check if inputdata exists to prevent errors
//     const dialCode = inputdata?.country?.dialCode || "";
//     onChange({
//       phoneNumber: val.slice(dialCode.length + 1),
//       countryCode: `+${dialCode}`,
//     });
//   };

//   return (
//     <div className={`flex flex-col ${className}`}>
//       {label && (
//         <label className="text-sm md:font-semibold font-medium text-gray-700 mb-1">
//           {label}
//         </label>
//       )}
//       <div className="mt-2 rounded-lg">
//         <PhoneInput
//           {...props}
//           defaultCountry={defaultCountry}
//           value={phone}
//           disabled={disabled}
//           onBlur={onBlur}
//           placeholder={placeholder}
//           onChange={handlePhoneChange ? handlePhoneChange : handleChange}
//           /* --- START OF CUSTOM FLAG SIZE --- */
//           countrySelectorStyleProps={{
//             // Adjust the button container width/height
//             buttonStyle: {
//               width: "36px",
//               height: "45px",
//               padding: "0 4px",
//             },
//             // Adjust the actual flag icon size
//             flagStyle: {
//               width: "18px",
//               height: "14px",
//             },
//           }}
//           /* --- END OF CUSTOM FLAG SIZE --- */

//           inputClassName={`w-full !border-2 !border-gray-200 rounded-lg px-4 !py-5 bg-gray-50 placeholder:text-sm text-sm ${inputClassName}`}
//           className="w-full"
//         />
//       </div>
//       {error && <div className="text-red-400 text-sm mt-1">{error}</div>}
//     </div>
//   );
// };
import React from "react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

export const PhoneNumber = ({
  label = "",
  defaultCountry = "in",
  className = "",
  onChange,
  onBlur,
  phone,
  placeholder,
  disabled,
  handlePhoneChange,
  error,
  inputClassName = "",
  ...props
}) => {
  const handleChange = (val, inputdata) => {
    const dialCode = inputdata?.country?.dialCode || "";
    onChange({
      phoneNumber: val.slice(dialCode.length + 1),
      countryCode: `+${dialCode}`,
    });
  };

  return (
    <div className={`flex flex-col ${className}`}>
      {label && (
        <label className="text-sm md:font-semibold font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <div className="mt-1 rounded-lg">
        <PhoneInput
          {...props}
          defaultCountry={defaultCountry}
          value={phone}
          disabled={disabled}
          onBlur={onBlur}
          placeholder={placeholder}
          onChange={handlePhoneChange ? handlePhoneChange : handleChange}
          countrySelectorStyleProps={{
            buttonStyle: {
              width: "36px",
              height: "45px",
              padding: "0 4px",
            },
            flagStyle: {
              width: "18px",
              height: "14px",
            },
          }}
          inputClassName={`w-full !border-2 !border-gray-200 rounded-lg px-4 !py-5 bg-gray-50 placeholder:text-sm text-sm ${inputClassName} h-[45px]`} // Set consistent height for the input field
          className="w-full"
        />
      </div>
      {error && <div className="text-red-400 text-sm mt-1">{error}</div>}
    </div>
  );
};
